import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import Seo from "@/components/seo/Seo";
import JsonLd from "@/components/seo/JsonLd";
import { breadcrumbLd } from "@/data/schema";
import { POSTS } from "@/data/blog";
import PageHero from "@/components/layout/PageHero";
import Reveal from "@/components/ui/reveal";

export default function BlogIndex() {
    return (
        <>
            <Seo
                title="Blog"
                path="/blog"
                description="Blog Groszownika: KSeF FA-2 krok po kroku, ZUS Wakacje 2026 i VAT-OSS dla branży IT. Praktyczna wiedza podatkowa dla JDG i freelancerów."
            />
            <JsonLd data={breadcrumbLd([{ name: "Start", path: "/" }, { name: "Blog", path: "/blog" }])} />
            <PageHero
                eyebrow="Blog"
                title="Baza wiedzy"
                subtitle="Praktyczne, rzeczowe poradniki podatkowe dla JDG i freelancerów."
            />
            <section className="py-16 lg:py-24">
                <div className="container-gr grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                    {POSTS.map((p, i) => (
                        <Reveal key={p.slug} delay={(i % 3) * 0.06}>
                            <Link
                                to={`/blog/${p.slug}`}
                                data-testid={`blog-card-${p.slug}`}
                                className="group flex h-full flex-col overflow-hidden rounded-2xl border border-border bg-card transition-transform hover:-translate-y-1"
                            >
                                <div className="aspect-[16/9] overflow-hidden bg-muted">
                                    <img src={p.cover} alt={p.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                                </div>
                                <div className="flex flex-1 flex-col p-6">
                                    <span className="w-fit rounded-full bg-gr-secondary px-3 py-1 font-mono text-[10px] font-semibold uppercase tracking-wider text-gr-primary dark:bg-gr-dsecondary dark:text-gr-dprimary">{p.category}</span>
                                    <h2 className="mt-4 text-xl leading-tight tracking-tight text-foreground">{p.title}</h2>
                                    <p className="mt-2 flex-1 text-sm text-muted-foreground">{p.description}</p>
                                    <div className="mt-4 flex items-center justify-between text-xs text-muted-foreground">
                                        <span className="inline-flex items-center gap-1"><Clock className="h-3.5 w-3.5" /> {p.readingTime}</span>
                                        <span className="inline-flex items-center gap-1 font-medium text-gr-primary dark:text-gr-dprimary">Czytaj <ArrowRight className="h-3.5 w-3.5" /></span>
                                    </div>
                                </div>
                            </Link>
                        </Reveal>
                    ))}
                </div>
            </section>
        </>
    );
}
